import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'propertyOptionTranslate',
})
export class PropertyOptionTranslatePipe implements PipeTransform {

	private readonly labels: Record<string, string> = {
		LockWhenCarConnected: $localize`:@@CableSettingsLockWhenCarConnected:Lock When Car Connected`,
		LockAutomatically: $localize`:@@CableSettingsLockAutomatically:Lock Automatically`,
		LockAlways: $localize`:@@CableSettingsLockAlways:Lock Always`,
		Auto: $localize`:@@StartModeAuto:Auto`,
		Manual: $localize`:@@StartModeManual:Manual`,
		WeekSchedule: $localize`:@@ScheduleTypeWeekSchedule:Week Schedule`,
		DelayedStart: $localize`:@@ScheduleTypeDelayedStart:Delayed Start`,
		Main: $localize`:@@PowerSharingConfigurationMain:Main`,
		Sub1: $localize`:@@PowerSharingConfigurationSub1:Sub1`,
		Sub2: $localize`:@@PowerSharingConfigurationSub2:Sub2`,
		Sub3: $localize`:@@PowerSharingConfigurationSub3:Sub3`,
		Disabled: $localize`:@@PowerSharingConfigurationDisabled:Disabled`,
		One: $localize`:@@SolarNumberOfPhasesOne:One`,
		Three: $localize`:@@SolarNumberOfPhasesThree:Three`,
	};

	transform(state?: string): string {
		if (!state) {
			return '';
		}

		return this.labels[state] ?? state;
	}

}


@Pipe({
	name: 'propertyBooleanTranslate',
})
export class PropertyBooleanTranslatePipe implements PipeTransform {

	transform(state: boolean): string {
		if (state) {
			return $localize`:@@Yes:Yes`;
		} else {
			return $localize`:@@No:No`;
		}
	}

}
